// extracted by mini-css-extract-plugin
module.exports = {"advert":"_2I6Ad","advertImg":"Dx8WR"};